import _Fab from "@material-ui/core/esm/Fab";
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import { CSSTransition } from 'react-transition-group';
import { TOOLBAR_ITEMS } from 'swag-client-common/constants';
import { Placement } from 'swag-client-common/constants';
import { Tooltip } from 'swag-client-common/components/info/tooltip';
import ArrowDropUp from '@material-ui/icons/ArrowDropUp';
import { DEFAULT_BUTTON } from '../../../../../../constants/styles';
import { DesignNote } from './components/design-note';
import { EditColors } from './components/edit-colors';
import { ConvertToOneColor } from './components/convert-to-one-color';
import CenterLogo from './components/center-logo';
import toolbarAnimationClasses from './toolbar.anim.scss';
import classes from './tools-panel.scss';
import appearAnimationClasses from './appear.anim.scss';
import { TopBar } from './components/top-bar';
const TOOLTIP_ANIMATION_TIME = 250;
const useStyles = makeStyles(() => ({
  button: _objectSpread({}, DEFAULT_BUTTON, {
    width: '27px',
    height: '27px',
    minHeight: '27px',
    fontSize: '12px',
    padding: 0,
    margin: 0,
    borderRadius: '0 5px 5px 0'
  }),
  icon: {
    transition: 'transform 500ms',
    fontSize: '21px'
  },
  iconToHide: {
    transform: 'rotate(-90deg)'
  },
  iconToShow: {
    transform: 'rotate(90deg)'
  }
}));
export function ToolsPanelComponent({
  className,
  isToolsPanelShown,
  isToolsEnabled,
  noSelectedLogos,
  isAddStoreShown,
  onShowWarningNoImage,
  onDesignSave,
  onClickShareDesign,
  onClickAddToStore,
  isTopButtonsShown,
  onClickConvertToOneColor,
  hasAdvancedPositioning,
  selectedMedia,
  disabled,
  changeOpenedToolbarItem,
  openedToolbarItem,
  isFullScreenMode,
  toggleForceHideToolbar,
  shouldShowForceHideButton,
  isMiddleButtonsShown,
  isFavoriteBtnShown,
  isFavourite = true,
  productId,
  onProductFavouriteClick,
  isLoggedIn,
  shouldShowToolsPanel,
  isOutOfStock,
  isAnyLogoUploaded
}) {
  const notLogoTypeMedia = selectedMedia && !selectedMedia.original;
  const myStyles = useStyles();
  const [stateIsToolsPanelShown, changeStateIsToolsPanelShown] = useState(false);
  const [tooltipTitle, setTooltipTitle] = useState('');
  const onShowWarning = e => {
    e.preventDefault();
    e.stopPropagation();
    onShowWarningNoImage();
  };
  useEffect(() => {
    if (!isToolsPanelShown && !openedToolbarItem) {
      changeOpenedToolbarItem(null);
    }
    changeStateIsToolsPanelShown(isToolsPanelShown);
  }, [changeOpenedToolbarItem, isToolsPanelShown, openedToolbarItem]);
  useEffect(() => {
    setTimeout(() => {
      setTooltipTitle(`${isToolsPanelShown ? 'Hide' : 'Show'} tools panel`);
    }, TOOLTIP_ANIMATION_TIME);
  }, [isToolsPanelShown]);
  function onChangeToolbarTab(key) {
    if (!isToolsPanelShown) {
      return null;
    }
    const value = openedToolbarItem === key ? null : key;
    changeOpenedToolbarItem(value);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(className, classes.container)
  }, /*#__PURE__*/React.createElement(TopBar, {
    onShowWarning: onShowWarning,
    onDesignSave: onDesignSave,
    onClickShareDesign: onClickShareDesign,
    onClickAddToStore: onClickAddToStore,
    noSelectedLogos: noSelectedLogos,
    isTopButtonsShown: isTopButtonsShown,
    isOutOfStock: isOutOfStock,
    isFavourite: isFavourite,
    productId: productId,
    onProductFavouriteClick: onProductFavouriteClick,
    isLoggedIn: isLoggedIn,
    isAddStoreShown: isAddStoreShown,
    isFavoriteBtnShown: isFavoriteBtnShown
  }), shouldShowToolsPanel && /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.fixedOnMiddle, {
      [classes.toolbarHidden]: isFullScreenMode || !isMiddleButtonsShown || !isAnyLogoUploaded
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.verticalAlign
  }, /*#__PURE__*/React.createElement(CSSTransition, {
    appear: true,
    classNames: toolbarAnimationClasses,
    in: stateIsToolsPanelShown,
    timeout: 800
  }, /*#__PURE__*/React.createElement(DesignNote, {
    isDisabled: false,
    isOpened: openedToolbarItem === TOOLBAR_ITEMS.DESIGN_NOTE,
    onChangeOpenedState: () => onChangeToolbarTab(TOOLBAR_ITEMS.DESIGN_NOTE)
  })), /*#__PURE__*/React.createElement(CSSTransition, {
    appear: true,
    classNames: toolbarAnimationClasses,
    in: stateIsToolsPanelShown,
    timeout: 900
  }, /*#__PURE__*/React.createElement(CenterLogo, {
    hasAdvancedPositioning: hasAdvancedPositioning,
    isDisabled: !isToolsEnabled || noSelectedLogos || disabled,
    isOpened: openedToolbarItem === TOOLBAR_ITEMS.CENTER_LOGO,
    onChangeOpenedState: () => {
      onChangeToolbarTab(TOOLBAR_ITEMS.CENTER_LOGO);
    }
  })), /*#__PURE__*/React.createElement(CSSTransition, {
    appear: true,
    classNames: toolbarAnimationClasses,
    in: stateIsToolsPanelShown,
    timeout: 1000
  }, /*#__PURE__*/React.createElement(EditColors, {
    isDisabled: !isToolsEnabled || noSelectedLogos || notLogoTypeMedia || disabled,
    isOpened: openedToolbarItem === TOOLBAR_ITEMS.EDIT_COLORS,
    onChangeOpenedState: () => {
      onClickConvertToOneColor();
      onChangeToolbarTab(TOOLBAR_ITEMS.EDIT_COLORS);
    }
  })), /*#__PURE__*/React.createElement(CSSTransition, {
    appear: true,
    classNames: toolbarAnimationClasses,
    in: stateIsToolsPanelShown,
    timeout: 1100
  }, /*#__PURE__*/React.createElement(ConvertToOneColor, {
    isDisabled: !isToolsEnabled || noSelectedLogos || notLogoTypeMedia || disabled,
    isOpened: openedToolbarItem === TOOLBAR_ITEMS.CONVERT_COLORS,
    onChangeOpenedState: () => {
      onClickConvertToOneColor();
      onChangeToolbarTab(TOOLBAR_ITEMS.CONVERT_COLORS);
    }
  })), /*#__PURE__*/React.createElement(CSSTransition, {
    in: true,
    timeout: TOOLTIP_ANIMATION_TIME,
    classNames: appearAnimationClasses,
    unmountOnExit: true
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.toolbarToggler
  }, /*#__PURE__*/React.createElement(Tooltip, {
    title: tooltipTitle,
    placement: Placement.RIGHT
  }, /*#__PURE__*/React.createElement(_Fab, {
    className: myStyles.button,
    onClick: () => toggleForceHideToolbar(isToolsPanelShown),
    color: "default",
    "aria-label": tooltipTitle
  }, /*#__PURE__*/React.createElement(ArrowDropUp, {
    className: classnames(myStyles.icon, {
      [myStyles.iconToShow]: !isToolsPanelShown,
      [myStyles.iconToHide]: isToolsPanelShown
    })
  }))))))));
}